import {
  useEffect,
  useState,
  type ComponentType,
} from "react";

import {
  useNavigate,
  useLocation,
} from "react-router-dom";

type RemoteComponent =
  ComponentType<Record<string, unknown>>;

export type UseOtpReturn = {
  otp: string;
  handleChange: (value: string) => void;
  handleSubmit: () => Promise<void>;
  maskedEmail: string;
  email: string;
  isValid: boolean;
  Button: RemoteComponent | null;
  Input: RemoteComponent | null;
  loading: boolean;
  submitting: boolean;
  authToken: string;
};

export default function useOtp(): UseOtpReturn {
  const [otp, setOtp] = useState("");

  const [Button, setButton] =
    useState<RemoteComponent | null>(null);

  const [Input, setInput] =
    useState<RemoteComponent | null>(null);

  const [authToken, setAuthToken] =
    useState("");

  const [authorized, setAuthorized] =
    useState(false);

  const [validating, setValidating] =
    useState(true);

  const [submitting, setSubmitting] =
    useState(false);

  const navigate = useNavigate();

  const location = useLocation();

  const email =
    sessionStorage.getItem(
      "invalidEmail"
    ) || "";

  const maskedEmail =
    location.state?.maskedEmail || "";

  useEffect(() => {
    const initialize = async () => {
      try {
        const token =
          sessionStorage.getItem(
            "AUTH_TOKEN"
          );

        const type =
          sessionStorage.getItem(
            "AUTH_TYPE"
          );

        if (!token || !type) {
          navigate("/", {
            replace: true,
          });
          return;
        }

        setAuthToken(token);

        const response = await fetch(
          `${import.meta.env.VITE_API_URL}/api/amibit/fwp/validate`,
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json",
            },
            body: JSON.stringify({
              token,
              type: Number(type),
            }),
          }
        );

        if (!response.ok) {
          throw new Error(
            `Validation failed: ${response.status}`
          );
        }

        const data =
          await response.json();

        if (!data.success) {
          navigate("/", {
            replace: true,
          });
          return;
        }

        setAuthorized(true);

        const buttonModule =
          await import(
            "remote_app/Button"
          );

        const inputModule =
          await import(
            "inputfield/Input"
          );

        setButton(
          () =>
            buttonModule.default as RemoteComponent
        );

        setInput(
          () =>
            inputModule.default as RemoteComponent
        );
      } catch (error) {
        console.error(
          "Token validation error:",
          error
        );

        navigate("/", {
          replace: true,
        });
      } finally {
        setValidating(false);
      }
    };

    initialize();
  }, [navigate]);

  const handleChange = (
    value: string
  ): void => {
    const onlyNumbers =
      value.replace(/[^0-9]/g, "");

    const limited =
      onlyNumbers.slice(0, 4);

    setOtp(limited);
  };

  const handleSubmit =
    async (): Promise<void> => {

    if (submitting) return;

    setSubmitting(true);

    try {
      const authService =
        (
          await import(
            "service1/authService"
          )
        ).default;

      const data =
        await authService.verifyOtp(
          {
            email,
            otp,
          },
          authToken
        );

      console.log(
        "OTP RESPONSE =",
        data
      );

      if (
        Number(data.statusType) === 1
      ) {

        sessionStorage.setItem(
          "userId",
          String(data.userId)
        );

        setTimeout(() => {
          navigate("/name");
        }, 500);

      } else {

        console.log(
          "Invalid OTP"
        );

      }

    } catch (error) {

      console.error(
        "API error:",
        error
      );

    } finally {

      setSubmitting(false);

    }
  };

  return {
    otp,
    handleChange,
    handleSubmit,
    email,
    maskedEmail,
    isValid: otp.length === 4,
    Button,
    Input,
    authToken,
    submitting,
    loading:
      validating ||
      !authorized ||
      !Button ||
      !Input,
  };
}